import Source from "../../Source";

// 트위치 채팅을 브라우저에서 직결 수신 (event-stream / direct).
// 익명 justinfan으로 wss://irc-ws.chat.twitch.tv 직결 — 우리 게이트웨이/서버 불필요(이름≠URL).
// WebSocket은 CORS 비대상 → 오버레이(OBS 브라우저소스)에서 바로 붙는다.
// 수신 → 게이트웨이 chzzk와 동일하게 StreamEvent({type:"CHAT"})로 _emit → 단일 인터프리터가 해석.
const TWITCH_IRC_URL = "wss://irc-ws.chat.twitch.tv:443";

export default class TwitchDirectSource extends Source {
  // channel: 트위치 로그인명(소문자, # 없이). 예: "xqc"
  constructor({ channel } = {}) {
    super({ provider: "twitch", kind: "event-stream", mode: "direct" });
    this._channel = (channel || "").toLowerCase().replace(/^#/, "");
    this._socket = null;
    this._onStatus = null;
    this._closedByUs = false;
    this._reconnectTimer = null;
  }

  // 채널 조인 성공(true) — 상태 아이콘용 (chzzk onStatus와 동일 시그니처)
  onStatus(cb) {
    this._onStatus = cb;
    return this;
  }

  open() {
    if (!this._channel) {
      console.warn("E_NO_TWITCH_CHANNEL : can not open twitch stream");
      return this;
    }
    this._closedByUs = false;
    this._connect();
    return this;
  }

  _connect() {
    this._setStatus("connecting");
    const socket = new WebSocket(TWITCH_IRC_URL);
    this._socket = socket;

    socket.onopen = () => {
      // 읽기전용 익명 접속: PASS 불필요. tags로 display-name 등 확보.
      socket.send("CAP REQ :twitch.tv/tags twitch.tv/commands");
      socket.send(`NICK justinfan${Math.floor(Math.random() * 90000) + 10000}`);
      socket.send(`JOIN #${this._channel}`);
    };

    socket.onmessage = (e) => {
      const raw = typeof e.data === "string" ? e.data : "";
      // 한 프레임에 여러 IRC 라인이 올 수 있다.
      raw.split("\r\n").forEach((line) => {
        if (!line) return;
        this._handleLine(line, socket);
      });
    };

    socket.onclose = () => {
      if (this._closedByUs) return;
      this._setStatus("connecting");
      // 예기치 못한 종료 → 백오프 재연결 (스트림 끊김 방지)
      this._reconnectTimer = setTimeout(() => this._connect(), 3000);
    };

    socket.onerror = () => {
      try {
        socket.close();
      } catch (error) {
        console.error(error);
      }
    };
  }

  _handleLine(line, socket) {
    // keep-alive: 서버 PING에 PONG 안 하면 연결이 끊긴다.
    if (line.startsWith("PING")) {
      socket.send("PONG :tmi.twitch.tv");
      return;
    }

    const parsed = this._parse(line);
    if (!parsed) return;

    // 001 = welcome(접속/조인 완료로 간주) → 상태 ON
    if (parsed.command === "001") {
      this._setStatus("ready");
      if (this._onStatus) this._onStatus(true);
      return;
    }

    if (parsed.command === "PRIVMSG") {
      const nickname = parsed.tags["display-name"] || parsed.nick || "익명";
      this._emit({
        type: "CHAT",
        message: parsed.message,
        hidden: false,
        profile: { nickname },
      });
    }
  }

  // IRCv3 파싱: [@tags] [:prefix] COMMAND [params] [:trailing]
  _parse(line) {
    let rest = line;
    const tags = {};

    if (rest[0] === "@") {
      const sp = rest.indexOf(" ");
      rest
        .slice(1, sp)
        .split(";")
        .forEach((pair) => {
          const eq = pair.indexOf("=");
          if (eq === -1) tags[pair] = true;
          else tags[pair.slice(0, eq)] = pair.slice(eq + 1);
        });
      rest = rest.slice(sp + 1);
    }

    let nick = null;
    if (rest[0] === ":") {
      const sp = rest.indexOf(" ");
      const prefix = rest.slice(1, sp);
      nick = prefix.split("!")[0];
      rest = rest.slice(sp + 1);
    }

    // COMMAND + 나머지. trailing(메시지 본문)은 첫 " :" 이후.
    const trailingIdx = rest.indexOf(" :");
    let message = "";
    let head = rest;
    if (trailingIdx !== -1) {
      message = rest.slice(trailingIdx + 2);
      head = rest.slice(0, trailingIdx);
    }
    const command = head.split(" ")[0];

    return { tags, nick, command, message };
  }

  close() {
    this._closedByUs = true;
    this._setStatus("closed");
    if (this._reconnectTimer) {
      clearTimeout(this._reconnectTimer);
      this._reconnectTimer = null;
    }
    if (this._socket) {
      try {
        this._socket.close();
      } catch (error) {
        console.error(error);
      }
      this._socket = null;
    }
  }
}
